export const getCurrentCurrency = ({ currentMarket = 'GB' }) => {
  const markets = {
    GB: {
      currencyCode: 'GBP',
      countryCode: 'en-GB',
    },
    US: {
      currencyCode: 'USD',
      countryCode: 'us-US',
    },
  }

  return (
    markets[currentMarket] || {
      currencyCode: 'EUR',
      countryCode: 'de-DE',
    }
  )
}

const getFormattedPrice = ({ currentMarket = 'GB', price = 0 }) =>
  Intl.NumberFormat(getCurrentCurrency({ currentMarket }).countryCode, {
    style: 'currency',
    currency: getCurrentCurrency({ currentMarket }).currencyCode,
  }).format(price)

export default getFormattedPrice
